import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

import type { UserInfo } from "~/auth/types/auth-provider";
import { getCurrentUser } from "~/auth/api/get-current-user";

const getCurrentUserQueryOptions = queryOptions({
  queryKey: ["current-user"],
  queryFn: getCurrentUser,
});

function useCurrentUser<TSelect = UserInfo>(
  select?: (data: UserInfo) => TSelect,
) {
  return useSuspenseQuery({
    ...getCurrentUserQueryOptions,
    select,
  });
}

export { getCurrentUserQueryOptions, useCurrentUser };
